var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13129_73669)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66944 4.75972C5.69625 4.53257 5.77573 4.31481 5.90155 4.1238C6.02737 3.93278 6.19607 3.77379 6.39419 3.65948C6.59231 3.54518 6.81438 3.47871 7.04272 3.46539C7.27107 3.45206 7.49937 3.49224 7.70944 3.58272C8.77144 4.03672 11.1514 5.11572 14.1714 6.85872C17.1924 8.60272 19.3174 10.1257 20.2404 10.8167C21.0284 11.4077 21.0304 12.5797 20.2414 13.1727C19.3274 13.8597 17.2284 15.3627 14.1714 17.1287C11.1114 18.8947 8.75944 19.9607 7.70744 20.4087C6.80144 20.7957 5.78744 20.2087 5.66944 19.2317C5.53144 18.0897 5.27344 15.4967 5.27344 11.9947C5.27344 8.49472 5.53044 5.90272 5.66944 4.75972Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13129_73669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.05fedf39182acd34459a2199cf1b3b30.svg";
export { ForwardRef as ReactComponent };